import { withApollo } from "react-apollo";
import Bookings from "../bookings/Bookings";
import { useParams } from "react-router-dom";

const BookingGroups = ({ subscriptionStatus, setSubscriptionStatus, setPopupEnableStatus }) => {
    const { groupName } = useParams();

    return <Bookings
        subscriptionStatus={subscriptionStatus}
        setSubscriptionStatus={setSubscriptionStatus}
        setPopupEnableStatus={setPopupEnableStatus}
        groupName={groupName}
        isGroupView={true}
    />


};

export default withApollo(BookingGroups);
